<template>
    <button
        type="button"
        class="clinic-nearby-chip"
        :class="{'clinic-nearby-chip--on': isActive}"
        :aria-pressed="isActive"
        :disabled="isPending"
        @click="emit('toggle')"
    >
        <SvgoGeoSend aria-hidden="true"/>
        <span>{{ isPending ? 'Определяем…' : 'Рядом со мной' }}</span>
    </button>
</template>

<script lang="ts" setup>
defineProps<{
    isActive?: boolean;
    isPending?: boolean;
}>();

const emit = defineEmits<{
    toggle: [];
}>();
</script>

<style lang="scss">
.clinic-nearby-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 40px;
    padding: 0 14px;
    border: 0;
    border-radius: 20px;
    background-color: $color-white;
    color: $color-gray;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
    cursor: pointer;
    @include transition(background-color color, 0.2s);

    svg {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
        color: $color-accent-text;
    }

    &:hover:not(:disabled) {
        background-color: $color-pink;
        color: $color-accent-text;
    }

    &--on {
        background-color: $color-pink;
        color: $color-accent-text;
    }

    &:disabled {
        cursor: default;
        opacity: 0.7;
    }

    &:focus-visible {
        outline: 2px solid $color-purple;
        outline-offset: 2px;
    }
}
</style>
